import React, {FC, useState, useEffect} from 'react';
import {navigate} from 'gatsby';
import {useQuery} from '@apollo/react-hooks';
import {GET_USER_WATCH_SETTINGS_QUERY} from '../../../graphql/queries';
import Payment from '../payment';
import PricingItem from '../pricing-item';
import Flag from '../pricing-flag';
import CustomModal from '../../customModal';
import {IPricingCard} from '../../types';
import {trialBadge} from '../../../images/svgIcons';
import './styles.scss';

const PricingCard: FC<IPricingCard> = ({
  trigger,
  name,
  price,
  flag,
  lineThrough,
  pricingList,
  user,
  disabled,
  packeges,
  verified,
  id,
  interval,
  refetch,
  isEnterprise,
  handleEnterpriseClick,
  promo,
  real_price,
  discountAnnual,
  paypal_id,
  ltdPrice,
  currentPlan,
  currentPlanInterval,
  pendingPayment,
  showLtd,
  annualDiscountPrice,
  showAnnualDiscount,
  selected,
  totalChecks,
  frequency,
  siteMapMonitor,
  specialLtd,
}) => {
  //state
  // const [selectedValue, setSelectedValue] = useState(
  //   selected
  //     ? selected
  //     : pricingList?.find((item: any) => item.options)?.options?.[0] || null,
  // );
  // const [selectedValue, setSelectedValue] = useState(null);
  const [showPaypalMessage, setShowPaypalMessage] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [packageInfo, setPackageInfo] = useState(null);
  const [verifyModal, setVerifyModal] = useState(false);
  const [canUseTrial, setCanUseTrial] = useState(true);
  const [trialPlans, setTrialPlans] = useState<string[]>(['PRO']);
  const [isTrialSelected, setIsTrialSelected] = useState(false);
  const [billedUponLTDBusiness, setBilledUponLTDBusiness] = useState<any>(null);
  const [billedUponLTDBusinessPlus, setBilledUponLTDBusinessPlus] = useState<any>(null);

  //useEffects
  // useEffect(() => {
  //   verified &&
  //     localStorage.getItem('packageInfo') &&
  //     //@ts-ignore
  //     setPackageInfo(JSON.parse(localStorage.getItem('packageInfo')));
  // }, [verified]);

  // useEffect(() => {
  //   if (packageInfo) {
  //     //@ts-ignore
  //     if (packageInfo.name === 'Gold') {
  //       //@ts-ignore
  //       setSelectedValue(packageInfo.selectedValue);
  //     }
  //     //@ts-ignore
  //     if (!disabled && packageInfo.name === name) {
  //       setShowModal(true);
  //       return;
  //     }
  //     if (
  //       name === 'Gold' &&
  //       //@ts-ignore
  //       packageInfo.name === 'Silver' &&
  //       user.pricing_package === 'GOLD'
  //     ) {
  //       !showModal && setShowModal(true);
  //     }
  //   }
  // }, [packageInfo]);

  const {data: hexowatchUserInfo} = useQuery(GET_USER_WATCH_SETTINGS_QUERY, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    const trial =
      hexowatchUserInfo &&
      hexowatchUserInfo.UserWatchSettings &&
      hexowatchUserInfo.UserWatchSettings.get &&
      typeof hexowatchUserInfo.UserWatchSettings.get.can_use_trial === 'boolean';
    const trialPackages =
      hexowatchUserInfo &&
      hexowatchUserInfo.UserWatchSettings &&
      hexowatchUserInfo.UserWatchSettings.get &&
      hexowatchUserInfo.UserWatchSettings.get.trial_packages;
    if (trial) {
      setCanUseTrial(trial);
      trialPackages && setTrialPlans(trialPackages);
    }
  }, [hexowatchUserInfo]);

  const proLtd = 175;
  const businessLtd = 350;
  const businessPlusLtd = 590;

  const proLtdNew = 99;
  const businessLtdNew = 198;
  const businessPlusLtdNew = 297;

  useEffect(() => {
    const billedUponLTDBusinessLocal = specialLtd
      ? currentPlan === 'PRO' && currentPlanInterval === 'LTD'
        ? businessLtdNew - proLtdNew
        : businessLtdNew
      : currentPlan === 'PRO' && currentPlanInterval === 'LTD'
      ? businessLtd - proLtd
      : businessLtd;
    const billedUponLTDBusinessPlusLocal = specialLtd
      ? currentPlan === 'PRO' && currentPlanInterval === 'LTD'
        ? businessPlusLtdNew - proLtdNew
        : currentPlan === 'BUSINESS_SCANS_10000' && currentPlanInterval === 'LTD'
        ? businessPlusLtdNew - businessLtdNew
        : businessPlusLtdNew
      : currentPlan === 'PRO' && currentPlanInterval === 'LTD'
      ? businessPlusLtd - proLtd
      : currentPlan === 'BUSINESS_SCANS_10000' && currentPlanInterval === 'LTD'
      ? businessPlusLtd - businessLtd
      : businessPlusLtd;
    setBilledUponLTDBusiness(billedUponLTDBusinessLocal);
    setBilledUponLTDBusinessPlus(billedUponLTDBusinessPlusLocal);
  }, [specialLtd, currentPlanInterval, currentPlan]);

  const handelClick = (trial?: boolean) => {
    setIsTrialSelected(!!trial);
    localStorage.setItem(
      'checkout-data',
      JSON.stringify({
        id,
        paypal_id,
        name,
        price: annualDiscountPrice
          ? annualDiscountPrice
          : interval === 'annual' && showLtd && name === 'Business'
          ? billedUponLTDBusiness
          : interval === 'annual' && showLtd && name === 'Business+'
          ? billedUponLTDBusinessPlus
          : interval === 'annual' && showLtd && name === 'Pro'
          ? specialLtd
            ? proLtdNew
            : proLtd
          : price,
        isTrial: !!trial,
        interval,
        ltd: showLtd,
        ltdUrl: showLtd ? `?promo=${specialLtd ? 2 : 1}` : '',
        totalChecks: totalChecks,
        frequency: frequency,
        siteMapMonitor: siteMapMonitor,
      }),
    );
    if (!user || !user.id) {
      // setItem();
      navigate('/registration');
      return;
    }
    // if (user && !verified) {
    //   setVerifyModal(true);
    //   return;
    // }
    name !== 'Free' && !disabled && navigate('/pricing/checkout/');
  };

  const ltdPriceAjusted = currentPlan === 'SILVER' && name === 'Gold' && currentPlanInterval === 'LTD' ? 199 : 0;

  const content = (
    <div className="pricing-card position-relative m-auto">
      {flag && <Flag color={flag.color} />}
      {canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly' && (
        <div className={`position-absolute trial-flag`}>{trialBadge} </div>
      )}
      <div className="pricing-card-header">
        <div className="name">{name}</div>
        {/*promo && interval === 'annual' && (
          <p className={`line-through w-100 mb-2 ${real_price ? '' : 'invisible'} my-0 f_size_22 text-center`}>
            <span>$ </span>
            {real_price}
            <span>/mo</span>
          </p>
        )*/}

        {isEnterprise ? (
          <div className="enterprice-txt text-center">Get a plan tailored to your unique business needs.</div>
        ) : (
          <>
            {promo && interval === 'annual' && (
              <p
                className={`line-through discount-price  ${
                  real_price || name !== 'Free' ? '' : 'invisible'
                } my-0 mx-auto f_size_22 text-center`}
              >
                <span>$ </span>
                {real_price}
                <span>/mo</span>
              </p>
            )}
            <div className="d-flex">
              <div
                className={`price ${lineThrough || ltdPrice ? 'line-through w-100' : ''} ${
                  annualDiscountPrice ? 'line-through sm' : ''
                }`}
              >
                <sup>$</sup>
                {interval === 'annual' && name === 'Business+'
                  ? 99
                  : interval === 'annual'
                  ? String(price / (!(lineThrough || ltdPrice || annualDiscountPrice) ? 12 : 10)).length > 4
                    ? (price / (!(lineThrough || ltdPrice || annualDiscountPrice) ? 12 : 10)).toFixed(2)
                    : price / (!(lineThrough || ltdPrice || annualDiscountPrice) ? 12 : 10)
                  : price}
                {annualDiscountPrice ? '' : <sub>/mo</sub>}
              </div>
              {annualDiscountPrice ? (
                <div className={`price`}>
                  <sup>$</sup>
                  {interval === 'annual' && name === 'Business'
                    ? 25
                    : interval === 'annual'
                    ? String(annualDiscountPrice / (!(lineThrough || ltdPrice) ? 12 : 10)).length > 4
                      ? (annualDiscountPrice / (!(lineThrough || ltdPrice) ? 12 : 10)).toFixed(2)
                      : annualDiscountPrice / (!(lineThrough || ltdPrice) ? 12 : 10)
                    : annualDiscountPrice}
                  <sub>/mo</sub>
                </div>
              ) : null}
            </div>
          </>
        )}
        {isEnterprise ? (
          <div>
            <button
              className={`enterprise-contact btn get-package ${promo && interval === 'annual' ? 'mt-2 pt-3' : ''}`}
              onClick={handleEnterpriseClick}
            >
              Contact us
            </button>
          </div>
        ) : (
          <div className={`${user && user.id && name === 'Free' ? 'invisible' : 'visible'}`}>
            <button
              className={`btn get-package ${
                canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly' ? 'trial-btn' : ''
              }`}
              onClick={() =>
                handelClick(!!(canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly'))
              }
              disabled={pendingPayment}
              title={pendingPayment ? 'You have pending payment' : ''}
            >
              {canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly'
                ? 'Try for free'
                : ltdPrice
                ? 'Buy now'
                : 'Subscribe'}
            </button>
          </div>
        )}
        {canUseTrial && interval === 'monthly' && trialPlans?.length ? (
          <div style={{visibility: trialPlans.includes(name.toUpperCase()) ? 'visible' : 'hidden'}}>
            or{' '}
            <span onClick={() => handelClick(false)} className="clickable-text ml-2">
              subscribe
            </span>
          </div>
        ) : (
          ''
        )}
        {!isEnterprise && (
          <div className="purchase">
            {(ltdPrice || annualDiscountPrice) && (
              <span className="mr-1 small-line-through-container">
                <span className="small-line-through">
                  $
                  {name === 'Gold'
                    ? false
                      ? ltdPrice - ltdPriceAjusted
                      : annualDiscountPrice
                      ? Math.round((price / 10) * 12)
                      : price
                    : annualDiscountPrice && name === 'Business+'
                    ? 1188
                    : annualDiscountPrice
                    ? Math.round((price / 10) * 12)
                    : price}
                </span>
              </span>
            )}
            <span style={{fontWeight: annualDiscountPrice ? 700 : 500}} className="mr-1">
              $
              {annualDiscountPrice
                ? annualDiscountPrice
                : interval === 'annual' && showLtd && name === 'Business'
                ? billedUponLTDBusiness
                : interval === 'annual' && showLtd && name === 'Business+'
                ? billedUponLTDBusinessPlus
                : interval === 'annual' && showLtd && name === 'Pro'
                ? specialLtd
                  ? proLtdNew
                  : proLtd
                : price}
            </span>
            {canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly'
              ? 'billed after 7-day free trial'
              : annualDiscountPrice
              ? 'billed annually'
              : 'billed upon purchase'}
          </div>
          // <div className="purchase">${name === 'Gold' ? price : price} billed upon purchase</div>
        )}
      </div>
      <div className="pricing-card-body">
        {pricingList?.map((item: any) => (
          <PricingItem
            text={item.text}
            ltdPrice={ltdPrice || annualDiscountPrice}
            // ltdPriceAjusted={ltdPriceAjusted}
            number={item.number}
            isBold={item.isBold}
            isChecked={item.isChecked}
            unlimited={item.unlimited}
            select={item.select}
            // selectedValue={selectedValue}
            // onChange={(val: any) => setSelectedValue(val)}
            options={item.options}
          />
        ))}
      </div>
    </div>
  );
  return (
    <>
      <div
        className={`pricing-card-container ${
          ltdPrice && name === 'Pro' ? 'top_left' : name === 'Pro' ? 'top_left' : isEnterprise ? 'bottom_right' : ''
        } ${name?.toLocaleLowerCase()?.replace('+', '_plus')} ${ltdPrice ? 'pricing-card-trigger' : ''} ${
          disabled ? 'pricing-card-disabled' : ''
        }`}
      >
        {ltdPrice && (
          <div className="pricing-trigger">
            <div className="pricing-trigger-wrapper"> LIFETIME DEAL ${ltdPrice}</div>
            <div id="triangle-down"></div>
          </div>
        )}

        <div className="trigger-container">
          <>
            {!!trigger && (
              <>
                <div className="pricing-trigger-wrapper"> LIFETIME DEAL ${trigger} </div>
                <div id="triangle-down"></div>
              </>
            )}
            {content}
          </>
        </div>
      </div>
      {showModal && (
        <CustomModal ShowPopup={showModal} noCloseIcon className={`payment-modal ${showPaypalMessage ? 'paypal' : ''}`}>
          <Payment
            name={isTrialSelected ? name + ' (7-day free trial)' : name}
            price={
              annualDiscountPrice
                ? annualDiscountPrice
                : interval === 'annual' && showLtd && name === 'Business'
                ? billedUponLTDBusiness
                : interval === 'annual' && showLtd && name === 'Business+'
                ? billedUponLTDBusinessPlus
                : interval === 'annual' && showLtd && name === 'Pro'
                ? specialLtd
                  ? proLtdNew
                  : proLtd
                : price
            }
            setShowPopup={setShowModal}
            packeges={packeges.map(item => {
              return {
                ...item,
                price: annualDiscountPrice
                  ? item.annualDiscountPrice
                  : interval === 'annual' && showLtd && item.name === 'Business'
                  ? billedUponLTDBusiness
                  : interval === 'annual' && showLtd && item.name === 'Business+'
                  ? billedUponLTDBusinessPlus
                  : interval === 'annual' && showLtd && item.name === 'Pro'
                  ? specialLtd
                    ? proLtdNew
                    : proLtd
                  : item.price,
              };
            })}
            id={id}
            refetchInfo={refetch}
            user={user}
            paypal_id={paypal_id}
            showPaypalMessage={showPaypalMessage}
            setShowPaypalMessage={setShowPaypalMessage}
          />
        </CustomModal>
      )}
    </>
  );
};

export default PricingCard;
